module.exports = __webpack_public_path__ + "assets/3.png";


//////////////////
// WEBPACK FOOTER
// ./images/3.png
// module id = 697
// module chunks = 0